"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var useTableData = function (_a) {
    var _b = _a.rewards, rewards = _b === void 0 ? [] : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'place',
                    label: t('place'),
                },
                {
                    field: 'prize',
                    label: t('prize'),
                },
            ],
            rows: [],
        };
        table.rows = rewards.map(function (item) {
            var _a, _b, _c, _d;
            if (!item)
                return null;
            return {
                place: react_1.default.createElement("span", null, item === null || item === void 0 ? void 0 : item.place),
                prize: (react_1.default.createElement("span", null,
                    ((item === null || item === void 0 ? void 0 : item.amount) || 0) > 0
                        ? "".concat(item === null || item === void 0 ? void 0 : item.amount, " ").concat(currentCurrency)
                        : (item === null || item === void 0 ? void 0 : item.freeSpins)
                            ? "".concat(item.freeSpins, " ").concat(t('fs').toLocaleUpperCase())
                            : (item === null || item === void 0 ? void 0 : item.loyaltyExp)
                                ? "".concat(item.loyaltyExp, " ").concat(t('loyalExp').toLocaleUpperCase())
                                : (item === null || item === void 0 ? void 0 : item.loyaltyPoints)
                                    ? "".concat(item.loyaltyPoints, " ").concat(t('points').toLocaleUpperCase())
                                    : item.physicalReward
                                        ? item.physicalReward.toLocaleUpperCase()
                                        : '',
                    (item === null || item === void 0 ? void 0 : item.bonus)
                        ? "".concat((item === null || item === void 0 ? void 0 : item.bonus.percents) || '', " ").concat(((_a = item === null || item === void 0 ? void 0 : item.bonus) === null || _a === void 0 ? void 0 : _a.amount) ? (_b = item === null || item === void 0 ? void 0 : item.bonus) === null || _b === void 0 ? void 0 : _b.amount : '', " ").concat(((_c = item === null || item === void 0 ? void 0 : item.bonus) === null || _c === void 0 ? void 0 : _c.freespins)
                            ? ((_d = item === null || item === void 0 ? void 0 : item.bonus) === null || _d === void 0 ? void 0 : _d.amount)
                                ? '+ '
                                : '' + (item === null || item === void 0 ? void 0 : item.bonus.freespins) + t('fs')
                            : '')
                        : '')),
            };
        });
        return table;
    }, [t, currentCurrency, rewards]);
};
exports.useTableData = useTableData;
